import React from 'react';


import style from './scoring-foot-style.module.scss';
import useIsLandscape from '../../../javascript/utils/use-is-landscape.js';


function ScoringFoot(Props) {
   const isLandscape = useIsLandscape();
   // console.log('>> ScoringFoot: ', Props)

   let styleHeight = '';
   if (Props.cssHeight === '20') {
      styleHeight = style.hight20;
   }

   return (
      <div className={`${style.foot} ${styleHeight} ${isLandscape ? style.footLandscape : style.footPortrait}`}>
         {Props.children}
      </div>
   );
}

export default ScoringFoot;